<template>
    <div class="storageData">
        <div class="storageInfo">
            <div class="storageItem photosSessions">
                <i class="fas fa-chalkboard-teacher"></i>
                {{ countSessions }} <span class="legend"> Sesions</span>
            </div>
            <div class="storageItem storedPhotos">
                <i class="fas fa-image"></i>
                {{ countPhotos }} <span class="legend"> Photos</span>
            </div>
            <div class="storageItem storedVideos">
                <i class="fas fa-video"></i>
                {{ countVideos }} <span class="legend"> Videos</span>
            </div>
            <div class="storageItem storageUsed">
                <i class="fas fa-database"></i>
                {{storageUsed}} <span class="legend"> Mg Used</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "storageData",
    data() {
        return {
            countSessions: 0,
            countPhotos:0,
            countVideos: 0,
            storageUsed: 0
        };
    },
};
</script>
<style lang="scss" scoped>
.storageInfo {
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
    flex-direction: row;
}
.storageItem {
    display: flex;
    gap: 5px;
    justify-content: flex-start;
    width: 48%;
    align-items: center;
}
.storageItem i {
    width: 20px;
    text-align: left;
    &.fa-image {width: 15px;}
}
.storageItem span.legend {
    font-size: 14px;
}
.storageItem span.legend {
    font-size: 12px;
}
</style>
